import React from 'react';
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

function SelexMBExplorerXP() {
  return (
    <div>
         <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

         <iframe
      src="/SelexMBExplorer/indexxp.html"
      width="100%"
      height="750px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexMBExplorerXP